import script from "./account-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./account-input.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__